import(/* webpackMode: "eager" */ "/workspace/web/app/page.tsx");
